import { Enums, Helpers } from '@bode-canada/core';
import { FilterType } from '@/components/filters/enums';
import PropertyStyleMapper
  from '@/components/features/comparables/shared/mappers/PropertyStyleMapper';
import { ComparablesFilterType } from '@/components/page-specific/comparables/enums';
import BuildingTypeMapper
  from '@/components/features/comparables/shared/mappers/BuildingTypeMapper';
import { QueryParams } from '@/constants/QueryParams';

export default class QueryBuilderFactory {
  static #getVacantLandFields(filters) {
    return this.#removeEmptyProperties({
      [QueryParams.Location]: [
        filters[ComparablesFilterType.Lng],
        filters[ComparablesFilterType.Lat],
      ],
      [QueryParams.Baths]: filters[FilterType.Baths],
      [QueryParams.Beds]: filters[FilterType.Beds],
      [QueryParams.TotalFinishSqft]: this.#removeEmptyProperties({
        min: filters[FilterType.FinishedArea].min,
        max: filters[FilterType.FinishedArea].max,
      }),
      [QueryParams.Parking]: filters[ComparablesFilterType.Parking],
      ...BuildingTypeMapper.mapFilterToRequestQuery(filters[FilterType.BuildingType]),
      ...BuildingTypeMapper.mapFilterToRequestQuery(filters[FilterType.BuildingClass]),
    });
  }

  static #getBuildingAndApartmentFields(filters) {
    return {
      [QueryParams.YearBuilt]: this.#removeEmptyProperties({
        min: filters[FilterType.YearBuilt].min,
        max: filters[FilterType.YearBuilt].max,
      }),
      ...PropertyStyleMapper.mapFilterToRequestQuery(filters[ComparablesFilterType.Style]),
    };
  }

  static getFields(filters, listingFilters) {
    const buildingType = filters[FilterType.BuildingType];

    switch (buildingType) {
      case Enums.BuildingClassEnum.VACANT_LAND:
        return {
          ...this.#getVacantLandFields(filters),
        };
      default:
        return {
          ...this.#getVacantLandFields(filters),
          ...this.#getBuildingAndApartmentFields(filters),
          listingFilters,
        };
    }
  }

  static #removeEmptyProperties(input) {
    const result = Helpers.ObjectHelper.removeEmptyProperties(input);

    return this.#checkObjectFields(result);
  }

  static #checkObjectFields(input) {
    return Object.keys(input).length ? input : null;
  }
}
